var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c(
        "DIV",
        { staticClass: "form-row" },
        [
          _vm.loaded
            ? _c(
                "DIV",
                { staticClass: "col-3" },
                [
                  _c("ItpFormInput", {
                    attrs: {
                      mask: "number",
                      unmask: "typed",
                      scale: "2",
                      name: "exchange_rate_value",
                      readonly: _vm.readonly,
                      placeholder: _vm._f("pgettext")(
                        "Rate",
                        "ExchangeRateFieldset"
                      )
                    },
                    on: {
                      blur: function($event) {
                        return _vm.evh_6466705138206980_blur($event, {})
                      }
                    },
                    model: {
                      value: _vm.item.value,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "value", $$v)
                      },
                      expression: "item.value"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loaded
            ? _c(
                "DIV",
                { staticClass: "col-4" },
                [
                  _c("ItpFormDatetime", {
                    attrs: {
                      name: "exchange_rate_date",
                      readonly: _vm.readonly,
                      placeholder: _vm._f("pgettext")(
                        "Date",
                        "ExchangeRateFieldset"
                      )
                    },
                    on: {
                      blur: function($event) {
                        return _vm.evh_3943151158818434_blur($event, {})
                      }
                    },
                    model: {
                      value: _vm.item.date,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "date", $$v)
                      },
                      expression: "item.date"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loaded
            ? _c(
                "DIV",
                { staticClass: "col-5" },
                [
                  _c("ItpFormSelect", {
                    attrs: {
                      name: "exchange_rate_source",
                      options: _vm.exchangeRateSources,
                      readonly: _vm.readonly,
                      placeholder: _vm._f("pgettext")(
                        "Provider",
                        "ExchangeRateFieldset"
                      ),
                      valueField: "value",
                      textField: "name"
                    },
                    on: {
                      blur: function($event) {
                        return _vm.evh_4207795475682514_blur($event, {})
                      }
                    },
                    model: {
                      value: _vm.item.source,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "source", $$v)
                      },
                      expression: "item.source"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }